import { Button, ButtonProps } from 'antd';
import classNames from 'classnames';
import { FC } from 'react';

import styles from './styles.module.less';

const HeaderButton: FC<ButtonProps> = ({
  className,
  disabled = false,
  ...rest
}) => (
  <Button
    className={classNames(className, styles.button, {
      [styles.disabled]: disabled,
    })}
    type="text"
    {...rest}
  />
);

HeaderButton.displayName = 'HeaderButton';

export default HeaderButton;
